import { render, staticRenderFns } from "./welcome-guide-helper-modal.vue?vue&type=template&id=53153b43&scoped=true&"
import script from "./welcome-guide-helper-modal.vue?vue&type=script&lang=js&"
export * from "./welcome-guide-helper-modal.vue?vue&type=script&lang=js&"
import style0 from "./welcome-guide-helper-modal.vue?vue&type=style&index=0&id=53153b43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53153b43",
  null
  
)

export default component.exports